import {Component, Input} from '@angular/core';
import {SharedBadgePositionEnum} from '../../../shared-models/shared-components/shared-badge';

@Component({
    selector: 'app-shared-badge',
    templateUrl: './shared-badge.component.html',
    styleUrls: ['./shared-badge.component.scss'],
    standalone: false
})
export class SharedBadgeComponent {
  /** Vertical placement of the badge dot */
  @Input() position: SharedBadgePositionEnum = SharedBadgePositionEnum.TopRight;

  /**
   * Value shown inside the badge.
   * * `undefined`, `null`, or empty string → show a plain dot.
   */
  @Input() value?: string | number | null;
  @Input() pulse = false;

  /** Combined class used by the template for positioning */
  get positionClass(): string {
    return `${this.position}`;
  }

  /** True when the badge should render a text/number pill */
  get hasValue(): boolean {
    return this.value !== undefined && this.value !== null && this.value !== '';
  }
}
